export default __webpack_public_path__ + "static/media/nilson-filho.5c40fe6e.jpg";